import { OrderSettingsEnum } from "Data/settings";

const data = Object.values(OrderSettingsEnum);
const length = data.length;

const returnDefault = () => {
  console.log("Error: passing default.");
  return data[0];
};

/**
 *
 * @param {string} index The index to be found in the enums
 * @returns The enum within the index
 */
export const getEnumOfOrderSettings = (index: string) => {
  if (!index) return returnDefault();

  const parsedIndex = parseInt(index);
  if (isNaN(parsedIndex)) return returnDefault();
  if (parsedIndex > length) return returnDefault();

  return data[parsedIndex];
};

/**
 *
 * @param {OrderSettingsEnum} value The enum to be compared with, for its index
 * @returns The index in which the enum is residing in
 */
export const getIndexOfOrderSettings = (value: OrderSettingsEnum) => {
  if (!value) return "0";

  const position = data.findIndex((d) => d === value)?.toString();
  return position ?? "0";
};
